import React, { useState, useEffect } from 'react';
import {Map, GoogleApiWrapper, Marker} from 'google-maps-react';

import { useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { getCarDetail } from "api";
import { CircularProgress } from "@material-ui/core";
import {commaNum} from "utils/func";
import {PATH_CAR_LIST, PATH_CONTACT} from "constants/path";


const useStyles = makeStyles({
    container: {
        minHeight: '100vh',
        backgroundColor: '#fff',
    },
});

const _CarDetail = (props) => {
    const theme = useTheme();

    const underXs = useMediaQuery(theme.breakpoints.down('xs'));
    const underSm = useMediaQuery(theme.breakpoints.down('sm'));

    const { match, google } = props;
    const id = match.params.id || 0;
    const classes = useStyles(props);

    const [loading, setLoading] = useState(true);
    const [car, setCar] = useState(null);
    const [imageIndex, setImageIndex] = useState(0);

    useEffect(() => {
        getCarDetail(id).then(res => {
            if (res.ok) {
                setCar(res.data);
            }
            setLoading(false);
        }).catch(e => {
            setLoading(false);
        });
    }, []);

    return (
        loading ?
            <div className={classes.loadingContainer}>
                <CircularProgress style={{color: '#666666'}} />
            </div>
            :
            (
                !car ?
                    <div className={classes.loadingContainer}>
                        <span className={classes.error}>해당 차량을 찾을 수 없습니다.</span>
                    </div>
                    :
                    <div className={classes.container}>
                        <div style={{width: '100%', paddingBottom: `${100 * (underXs ? 310 : 683) / (underXs ? 375 : 1152)}%`, position: 'relative', backgroundImage: `url(${car.images[imageIndex].image})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
                            <div style={{
                                color: 'white',
                                position: 'absolute',
                                bottom: underXs ? 7 : (underSm ? 10 : 15),
                                left: underXs ? 13 : (underSm ? 28 :54),
                                borderRadius: 50,
                                backgroundColor: 'rgba(9, 9, 9, 0.5)',
                                fontWeight: '500',
                                fontSize: underXs ? 12 : (underSm ? 18 : 22),
                                padding: `${underXs ? 3 : (underSm ? 6 : 12)}px ${underXs ? 12 : (underSm ? 16 : 18)}px`}}>{imageIndex + 1}/{car.images.length}</div>
                            {
                                imageIndex > 0 &&
                                <div style={{position: 'absolute', top: '50%', left: underXs ? 20: (underSm ? 36 :54), transform: 'translateY(-50%)', cursor: 'pointer'}} onClick={() => setImageIndex(imageIndex - 1)}>
                                    <img src={require('assets/img/arrow_left.svg')} alt="arrow" style={{width: underXs ? 36: (underSm ? 48 : 58), height: underXs ? 36: (underSm ? 48 : 58),}}/>
                                </div>
                            }
                            {
                                imageIndex + 1 < car.images.length &&
                                <div style={{position: 'absolute', top: '50%', right: underXs ? 20: (underSm ? 36 :54), transform: 'translateY(-50%)', cursor: 'pointer'}} onClick={() => setImageIndex(imageIndex + 1)}>
                                    <img src={require('assets/img/arrow_right.svg')} alt="arrow" style={{width: underXs ? 36: (underSm ? 48 : 58), height: underXs ? 36: (underSm ? 48 : 58),}}/>
                                </div>
                            }
                        </div>
                        {
                            underXs ?
                            <div>
                                <span style={{fontWeight: '700', fontSize: 22, color: '#090909', margin: '16px 24px 38px 24px', display: 'inline-block'}}>{car.name}</span>

                                <span style={{display: 'block', margin: '0px 24px 10px 24px', fontSize: 14, fontWeight: '500', color: '#5E5E5E'}}>소개</span>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1}} />
                                <div style={{display: 'inline-box', marginLeft: 24, marginRight: 24, marginTop: 14, marginBottom: 20, fontSize: 14, color: '#090909', fontWeight: '400'}}>
                                    {
                                        car.detail.split('\n').map((e, i) => {
                                            return (
                                                <span key={i}>
                                                    {e}
                                                    <br />
                                                </span>
                                            )
                                        })
                                    }
                                </div>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1, marginBottom: 40}} />

                                <span style={{display: 'block', margin: '0px 24px 10px 24px', fontSize: 14, fontWeight: '500', color: '#5E5E5E'}}>연식</span>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1}} />
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 24, padding: '6px 0'}}>
                                    <div style={{height: 43, width: 66, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                        <img src={require('assets/img/car.png')} alt="Car" style={{width: 43, height: 43,}} />
                                    </div>
                                    <span style={{color: '#090909', fontSize: 14,}}>{car.year}년형</span>
                                </div>

                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1, marginBottom: 40}} />

                                <span style={{display: 'block', margin: '0px 24px 10px 24px', fontSize: 14, fontWeight: '500', color: '#5E5E5E'}}>배기량</span>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1}} />
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 24, padding: '6px 0'}}>
                                    <div style={{height: 43, width: 66, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                        <img src={require('assets/img/displacement.svg')} alt="Car" style={{width: 33, height: 33, marginLeft: 5,}} />
                                    </div>
                                    <span style={{color: '#090909', fontSize: 14,}}>{commaNum(car.displacement)} cc</span>
                                </div>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1, marginBottom: 40}} />

                                <span style={{display: 'block', margin: '0px 24px 10px 24px', fontSize: 14, fontWeight: '500', color: '#5E5E5E'}}>주유량</span>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1}} />
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 24, padding: '6px 0'}}>
                                    <div style={{height: 43, width: 66, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                        <img src={require('assets/img/fuel.png')} alt="Car" style={{width: 33, height: 33, marginLeft: 5,}} />
                                    </div>
                                    <span style={{color: '#090909', fontSize: 14,}}>{commaNum(car.fuel)} %</span>
                                </div>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1, marginBottom: 40}} />

                                <span style={{display: 'block', margin: '0px 24px 10px 24px', fontSize: 14, fontWeight: '500', color: '#5E5E5E'}}>이용금액</span>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1}} />
                                <div style={{padding: '8px 16px'}}>
                                    <div style={{display: 'flex', height: 44, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '0px 11px'}}>
                                        <span style={{color: '#090909', fontWeight: '500', fontSize: 14,}}>시간당 이용금액</span>
                                        <span style={{fontSize: 14, color: '#090909'}}>{commaNum(car.charge_per_hour)}원</span>
                                    </div>
                                    <div style={{width: '100%', height: 1, backgroundColor: '#c4c4c4'}} />
                                    <div style={{display: 'flex', height: 44, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '0px 11px'}}>
                                        <span style={{color: '#090909', fontWeight: '500', fontSize: 14,}}>주유비</span>
                                        <span style={{fontSize: 14, color: '#090909'}}>{commaNum(car.fuel_cost)}원</span>
                                    </div>
                                    <div style={{width: '100%', height: 1, backgroundColor: '#c4c4c4'}} />
                                    <div style={{display: 'flex', height: 44, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '0px 11px'}}>
                                        <span style={{color: '#090909', fontWeight: '500', fontSize: 14,}}>톨게이트비</span>
                                        <span style={{fontSize: 14, color: '#090909'}}>{commaNum(car.toll_cost)}원</span>
                                    </div>
                                </div>

                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1, marginBottom: 40}} />

                                <span style={{display: 'block', margin: '0px 24px 10px 24px', fontSize: 14, fontWeight: '500', color: '#5E5E5E'}}>차량 위치</span>
                                <div style={{width: '100%', backgroundColor: '#C4C4C4', height: 1,}} />
                                <div style={{padding: '0px 16px'}}>
                                    <div style={{padding: '16px 21px', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                        <div style={{width: 61}}>
                                            <img src={require('assets/img/pin.svg')} alt="Pin" style={{width: 22.5, height: 28.8}}/>
                                        </div>
                                        <div style={{flex: 1, color: '#090909', fontSize: 14}}>
                                            {car.address}
                                        </div>

                                    </div>
                                    <div style={{width: '100%', height: 1, backgroundColor: '#c4c4c4'}} />
                                </div>
                            </div>
                            :
                            <div>
                                <div style={{width: 720, margin: 'auto'}}>
                                    <div style={{width: '100%', margin: `${underSm ? 56 : 70}px 0px`, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                        <span style={{color: '#090909', fontSize: underSm ? 27 : 34, fontWeight: '500'}}>
                                            {car.name}
                                        </span>
                                        <div style={{textAlign: 'center'}}>
                                            <span style={{marginBottom: 24, display: 'inline-block', fontSize: underSm ? 32 : 38, fontWeight: '500', color: '#090909'}}>₩ {commaNum(car.charge_per_hour)} <span style={{fontWeight: '400', fontSize: underSm ? 18 : 22, color: '#5E5E5E'}}>시간당</span></span>
                                            <div
                                                onClick={() => {
                                                    props.history.push(`/${PATH_CONTACT}`);
                                                }}
                                                style={{cursor: 'pointer', width: underSm ? 240 : 268, height: underSm ? 58 : 70, backgroundColor: 'rgba(9, 147, 212, 0.78)', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: underSm ? 24 : 28, fontWeight: '500',}}>
                                                예약 문의하기
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{width: '100%', height: 1, backgroundColor: '#C4C4C4'}} />

                                    <div style={{padding: `${underSm ? 42 : 48}px 120px`, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div style={{textAlign: 'center'}}>
                                            <span style={{fontWeight: '500', fontSize: underSm ? 17 : 20, color: '#5E5E5E'}}>
                                                연식
                                            </span>
                                            <div style={{height: underSm ? 75 : 85, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                                <img src={require('assets/img/car.png')} alt="Car" style={{width: underSm ? 75 : 85, height: underSm ? 75 : 85}} />
                                            </div>
                                            <span style={{fontSize: underSm ? 20 : 22, color: '#090909'}}>
                                                {car.year}년형
                                            </span>
                                        </div>
                                        <div style={{textAlign: 'center'}}>
                                            <span style={{fontWeight: '500', fontSize: underSm ? 17 : 20, color: '#5E5E5E'}}>
                                                배기량
                                            </span>
                                            <div style={{height: underSm ? 75 : 85, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                                <img src={require('assets/img/displacement.svg')} alt="Car" style={{width: underSm ? 52 : 60, height: underSm ? 52 : 60}} />
                                            </div>
                                            <span style={{fontSize: underSm ? 20 : 22, color: '#090909'}}>
                                                {commaNum(car.displacement)} cc
                                            </span>
                                        </div>
                                        <div style={{textAlign: 'center'}}>
                                            <span style={{fontWeight: '500', fontSize: underSm ? 17 : 20, color: '#5E5E5E'}}>
                                                주유량
                                            </span>
                                            <div style={{height: underSm ? 75 : 85, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                                <img src={require('assets/img/fuel.png')} alt="Car" style={{width: underSm ? 52 : 60, height: underSm ? 52 : 60}} />
                                            </div>
                                            <span style={{fontSize: underSm ? 20 : 22, color: '#090909'}}>
                                                {car.fuel} %
                                            </span>
                                        </div>

                                    </div>

                                    <div style={{width: '100%', height: 1, backgroundColor: '#C4C4C4'}} />

                                    <div style={{margin: '50px 0px', display: 'flex', flexDirection: 'row',}}>
                                        <span style={{width: 125, display: 'inline-box', fontWeight: '500', fontSize: underSm ? 17 : 20, color: '#5E5E5E'}}>소개</span>
                                        <span style={{display: 'inline-box', flex: 1, fontSize: underSm ? 19 : 22, color: '#090909', fontWeight: '400'}}>
                                            {
                                                car.detail.split('\n').map((e, i) => {
                                                    return (
                                                        <span key={i}>
                                                            {e}
                                                            <br />
                                                        </span>
                                                    )
                                                })
                                            }
                                        </span>
                                    </div>

                                    <div style={{width: '100%', height: 1, backgroundColor: '#C4C4C4'}} />

                                    <div style={{margin: '32px 0px', display: 'flex', flexDirection: 'row',}}>
                                        <span style={{width: 125, marginTop: 18, display: 'inline-box', fontWeight: '500', fontSize: underSm ? 17 : 20, color: '#5E5E5E'}}>이용금액</span>
                                        <div style={{flex: 1}}>
                                            <div style={{display: 'flex', width: '100%', backgroundColor: 'rgba(63, 171, 221, 0.09)', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '18px 22px'}}>
                                                <span style={{color: '#090909', fontSize: underSm ? 19 : 22,}}>시간당 이용금액</span>
                                                <span style={{color: '#090909', fontSize: underSm ? 19 : 22,}}>{commaNum(car.charge_per_hour)}원</span>
                                            </div>
                                            <div style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '18px 22px'}}>
                                                <span style={{color: '#090909', fontSize: underSm ? 19 : 22,}}>주유비</span>
                                                <span style={{color: '#090909', fontSize: underSm ? 19 : 22,}}>{commaNum(car.fuel_cost)}원</span>
                                            </div>
                                            <div style={{display: 'flex', width: '100%', backgroundColor: 'rgba(63, 171, 221, 0.09)', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '18px 22px'}}>
                                                <span style={{color: '#090909', fontSize: underSm ? 19 : 22,}}>톨게이트비</span>
                                                <span style={{color: '#090909', fontSize: underSm ? 19 : 22,}}>{commaNum(car.toll_cost)}원</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{width: '100%', height: 1, backgroundColor: '#C4C4C4'}} />

                                    <div style={{margin: '40px 0px 40px 0px', display: 'flex', flexDirection: 'row',}}>
                                        <span style={{width: 125, display: 'inline-box', fontWeight: '500', fontSize: underSm ? 17 : 20, color: '#5E5E5E'}}>차량 위치</span>
                                        <span style={{display: 'inline-box', flex: 1, fontSize: underSm ? 19 : 22, color: '#090909', fontWeight: '400'}}>{car.address}</span>
                                    </div>
                                </div>
                            </div>
                        }
                        <div style={{position: 'relative', marginTop: 15, width: '100vw', height: 454,}}>
                            <Map
                                google={google}
                                zoom={16}
                                style={{width: '100%', height: '100%', position: 'relative',}}
                                initialCenter={{ lat: car.latitude, lng: car.longitude}}
                                zoomControl={false}
                                fullscreenControl={false}
                                streetViewControl={false}
                                mapTypeControl={false}
                                scaleControl={false}
                                panControl={false}
                                rotateControl={false}
                            >
                                <Marker
                                    position={{ lat: car.latitude, lng: car.longitude}} />
                            </Map>
                        </div>
                        {
                            underXs ?
                            <div style={{padding: '40px 16px'}}>
                                <a href={`tel:01075362403`}>
                                <div style={{width: '100%', padding: '15px 0', backgroundColor: 'rgba(9, 147, 212, 0.78)', color: 'white', fontWeight: '500', fontSize: 20, textAlign: 'center',}}>
                                    전화 예약하기
                                </div>
                                </a>
                            </div>
                            :
                            <div style={{height: 50}} />
                        }
                    </div>
            )
    );
};

export const CarDetail = GoogleApiWrapper({
    apiKey: 'AIzaSyCx0hQlJ2vj4QrrtZOL2EYMQs2jQAlMUis',
})(_CarDetail);